<template>
  <div>
    <div class="flex flex-wrap -m-1.5 xl:-m-2 2xl:-m-2.5">
      <div
        class="p-1.5 xl:p-2 2xl:p-2.5 lg:w-1/3"
        :class="$route.query.region ? 'w-full md:w-1/2' : 'w-full'"
      >
        <StatisticCard
          :loading="loading"
          :title="$t('total_#_buildings_structures')"
          :count="data['total_#_buildings'] || 0"
          class="bg-indigo-50 text-indigo-800 cursor-pointer h-full"
          @click="
            $router.push(
              `/building-list/${role == 'ministry_admin' || role == 'main_org_admin' ? 'new' : 'exg'}`
            )
          "
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('new_buildings_structures')"
          :count="data.new_buildings || 0"
          :img="require('@/assets/img/icons/organization.svg')"
          class="bg-sky-50 text-sky-600 cursor-pointer h-full"
          @click="$router.push('/building-list/exg')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('existing_buildings_structures')"
          :count="data.existing_buildings || 0"
          :img="require('@/assets/img/icons/flat.svg')"
          class="bg-blue-50 text-blue-600 cursor-pointer h-full"
          @click="$router.push('/building-list/exg')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('sustainable_buildings')"
          :count="data.sustainable_buildings || 0"
          :img="require('@/assets/img/safebuilding.svg')"
          class="bg-emerald-50 text-emerald-600 cursor-pointer h-full"
          @click="$router.push('/statistica/building/1,2')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('not_sustainable_buildings')"
          :count="data.not_sustainable_buildings || 0"
          :img="require('@/assets/img/not_sustainable_buildings.svg')"
          class="bg-orange-50 text-amber-600 cursor-pointer h-full"
          @click="$router.push('/statistica/building/3')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('not_sustainable_buildings4')"
          :count="data.not_sustainable_buildings4 || 0"
          :img="require('@/assets/img/buildingbreak.svg')"
          class="bg-rose-50 text-rose-600 cursor-pointer h-full"
          @click="$router.push('/statistica/building/4')"
        />
      </div>
      <div
        class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3"
        v-if="['admin', 'org_admin', 'main_org_admin', 'supervisor'].includes(role) && !$route.query.region"
      >
        <StatisticCard
          :loading="loading"
          :title="$t('transport_category_1')"
          :count="data.sustainable_tf || 0"
          :img="require('@/assets/img/icons/transport_category_1.svg')"
          class="bg-emerald-50 text-emerald-600 cursor-pointer h-full"
          @click="$router.push('/statistica/transport/1,2')"
        />
      </div>
      <div
        class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3"
        v-if="['admin', 'org_admin', 'main_org_admin', 'supervisor'].includes(role) && !$route.query.region"
      >
        <StatisticCard
          :loading="loading"
          :title="$t('not_sustainable_transport')"
          :count="data.not_sustainable_tf3 || 0"
          :img="require('@/assets/img/icons/transport_category_2.svg')"
          class="bg-orange-50 text-amber-600 cursor-pointer h-full"
          @click="$router.push('/statistica/transport/3')"
        />
      </div>
      <div
        class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3"
        v-if="['admin', 'org_admin', 'main_org_admin', 'supervisor'].includes(role) && !$route.query.region"
      >
        <StatisticCard
          :loading="loading"
          :title="$t('transport_category_3')"
          :count="data.not_sustainable_tf4 || 0"
          :img="require('@/assets/img/icons/transport_category_3.svg')"
          class="bg-rose-50 text-rose-600 cursor-pointer h-full"
          @click="$router.push('/statistica/transport/4')"
        />
      </div>
      <div
        class="p-1.5 xl:p-2 2xl:p-2.5 order-last lg:order-none w-full lg:w-1/2"
      >
        <PieChart
          :series="series"
          :labels="labels"
          :loading="loading"
          class="h-full justify-center p-5 rounded-2xl bg-slate-100"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full lg:w-1/2">
        <div class="flex flex-wrap -m-1.5 xl:-m-2 2xl:-m-2.5">
          <div
            class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-full"
            v-if="!$route.query.region"
          >
            <StatisticCard
              :loading="loading"
              :title="$t('an_incomplete_new_building')"
              :count="data.an_incomplete_new_building || 0"
              :img="require('@/assets/img/icons/uncomplatenew.svg')"
              class="bg-slate-100 text-slate-600 cursor-pointer h-full"
              @click="$router.push('/statistica/buildings/uncomplatenew')"
            />
          </div>
          <div
            class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-full"
            v-if="!$route.query.region"
          >
            <StatisticCard
              :loading="loading"
              :title="$t('an_incomplete_building')"
              :count="data.an_incomplete_building || 0"
              :img="require('@/assets/img/icons/an_incomplete_building.svg')"
              class="bg-stone-100 text-stone-600 cursor-pointer h-full"
              @click="$router.push('/statistica/buildings/uncomplate')"
            />
          </div>
          <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-full">
            <StatisticCard
              :loading="loading"
              :title="$t('invest_not_sustainable_buildings')"
              :count="data.invest_buildings || 0"
              :img="require('@/assets/img/icons/team.svg')"
              class="bg-cyan-50 text-cyan-600 cursor-pointer h-full"
              @click="$router.push('/investment/3')"
            />
          </div>
          <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-full">
            <StatisticCard
              :loading="loading"
              :title="$t('users')"
              :count="data.users || 0"
              :img="require('@/assets/img/icons/invest_card.svg')"
              class="bg-violet-50 text-violet-600 cursor-pointer h-full"
              @click="$router.push('/users')"
            />
          </div>
        </div>
      </div>
      <div
        v-if="['admin', 'org_admin', 'ministry_admin', 'main_org_admin', 'supervisor'].includes(role)"
        class="p-1.5 xl:p-2 2xl:p-2.5 w-full"
      >
        <div
          class="flex flex-wrap gap-2 items-center mb-1.5 xl:mb-2 2xl:mb-2.5"
        >
          <button
            class="px-4 py-2 rounded-xl "
            :class="
              mapType == '1'
                ? 'bg-indigo-800 text-white hover:bg-indigo-700'
                : 'bg-slate-50 hover:bg-slate-100 text-slate-800'
            "
            @click="mapType = '1'"
          >
            {{ $t("map_of_buildings_structures") }}
          </button>
          <button
            class="px-4 py-2 rounded-xl"
            :class="
              mapType == '2'
                ? 'bg-indigo-800 text-white hover:bg-indigo-700'
                : 'bg-slate-50 hover:bg-slate-100 text-slate-800'
            "
            @click="mapType = '2'"
          >
            {{ $t("count_of_buildings") }}
          </button>
          <el-select
            v-if="mapType == '1'"
            v-model="finalconclusion"
            :placeholder="$t('finalconclusion')"
            clearable
            style="width: 350px;"
          >
            <el-option
              v-for="item in dictionary.finalconclusion"
              :key="item.id"
              :label="
                item[`name_${$i18n.locale}`]
                  ? item[`name_${$i18n.locale}`]
                  : item.name_cyr
              "
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <dashboard-ymap
          v-if="mapType == '1'"
          :finalconclusion="finalconclusion"
        />
        <UzMap v-else :data="MapData" />
      </div>
    </div>
    <pre>{{ data }}</pre>
  </div>
</template>

<script>
import StatisticCard from "./Card.vue";
import PieChart from "@/components/PieChart.vue";
import dashboardYmap from "@/components/Dashboard/ymap.vue";
import UzMap from "@/components/UzMap.vue";

export default {
  name: "BuildingStatistic",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    StatisticCard,
    PieChart,
    dashboardYmap,
    UzMap,
  },
  computed: {
    dictionary() {
      return this.$store.state.dictionary;
    },
    role() {
      return this.$store.state.role;
    },
    series() {
      return [
        this.data.sustainable_buildings || 0,
        this.data.not_sustainable_buildings || 0,
        this.data.not_sustainable_buildings4 || 0,
      ];
    },
  },
  data() {
    return {
      labels: [
        this.$t("sustainable_buildings"),
        this.$t("not_sustainable_buildings"),
        this.$t("not_sustainable_buildings4"),
      ],
      mapType: "1",
      finalconclusion: undefined,
      MapData: [],
    };
  },
};
</script>

<style lang="scss" scoped></style>
